// @flow weak

import React from 'react';

const PopoverMessage = ({ children }) => <div>{children}</div>;

export default PopoverMessage;
